import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Done } from '@mui/icons-material';
import parse from 'html-react-parser';

const PlatformFeatures = ({
  features,
  color,
}: {
  features: string;
  color: string;
}) => {
  const platformFeatures = features
    ?.split(';')
    ?.map((feature) => feature.trim())
    .filter(Boolean);

  return (
    <List sx={{ padding: '0.5rem 2rem', maxHeight: '100%' }}>
      {platformFeatures.map((feature) => {
        const startsWithEverythingIn = feature
          .trim()
          .toLowerCase()
          .startsWith('everything in');

        return (
          <ListItem key={feature} disablePadding className="mb-2">
            {!startsWithEverythingIn && (
              <ListItemIcon
                className="min-w-8"
                sx={{
                  alignSelf: 'flex-start',
                  marginTop: 1,
                }}
              >
                <Done htmlColor={color} fontSize="medium" />
              </ListItemIcon>
            )}
            <ListItemText
              primary={parse(feature)}
              data-testid="platform-feature-name"
              sx={{
                '& > span': {
                  color: (theme) =>
                    theme.palette.mode === 'dark'
                      ? `${theme.palette.common.manatee} !important`
                      : `${theme.palette.common.gunmetal} !important`,
                  fontSize: '1rem',
                  ...(startsWithEverythingIn && {
                    fontWeight: 600,
                  }),
                },
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default PlatformFeatures;
